<div class="geospatial-preview-container">
    <div class="preview-map-container">
        <!-- @if (importWizardStorage.mapKey() >= 0) { -->
            <app-import-wizard-geospatial-minimap></app-import-wizard-geospatial-minimap>
        <!-- } -->
    </div>
    
    <div class="preview-feature-container">
        <input 
          type="text" 
          placeholder="Busque uma ou mais features" 
          class="search-input search-input-dimension" 
          (input)="search($event)"
        >
        <span class="preview-table-title">Preview das primeiras {{ total() }} de {{ fileTotalRows() }} linhas</span>
        <cdk-virtual-scroll-viewport  
        class="table-wrapper" 
        [itemSize]="52" 
        [maxBufferPx]="1200" 
        [minBufferPx]="400"
        >
            <table mat-table [dataSource]="featureTableDataSource()" *ngIf="total() > 0; else noFeatures">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Nome </th>
                    <td mat-cell *matCellDef="let feature">
                    {{ feature.name || '-' }}
                    </td>
                </ng-container>
                <ng-container *ngFor="let column of columns_names()">
                    <ng-container [matColumnDef]="column">
                        <th mat-header-cell *matHeaderCellDef> {{ column }} </th>
                        <td mat-cell *matCellDef="let row">
                            {{ row[column] == "" || row[column] == null ?
                             '--' : 
                             row[column] 
                             }}
                        </td>
                    </ng-container>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="columns_names(); sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: columns_names()"></tr>
            </table>
        </cdk-virtual-scroll-viewport>
        <mat-paginator 
            *ngIf="total() > 0"
            [length]="total()"
            [pageSize]="pageSize()"
            [pageSizeOptions]="pagesSizesArray"
            aria-label="Selecione a pagina"
            [showFirstLastButtons]="true"
            (page)="handlePageChange($event)">
        </mat-paginator>
        <div class="button-container">
            <button 
            class="secondary" 
            (click)="handleCancelClick()"
            [innerText]="_state().MultiFeatured ? 'Voltar' : 'Cancelar'"
            ></button>
            <button 
            class="primary" 
            [innerText]="isPreviewStep ? 'Iniciar importação' : 'Próximo'" 
            (click)="handleButtonClick()"
            *ngIf="!_state().MultiFeatured"
            ></button>
        </div>
    </div>
</div>
<app-alert 
title="Cancelar importação"
message="Deseja realmente cancelar essa importação? Todo o progresso será perdido."
confirmText="Confirmar"
cancelText="Voltar"
[visible]="isAlertVisible"
(onConfirmEvent)="handleCancelClickConfirmation()"
(onCancelEvent)="handleCancelClickCancel()"
></app-alert>
<ng-template class="table-wrapper" #noFeatures>
    <div class="no-features-container" *ngIf="!isLoading()">
        <div class="status-icon warning-icon">
            public_off
        </div>
        <div class="warning-title">
            Nenhuma geometria encontrada
        </div>
        <div class="warning-description">
            O arquivo geoespacial não possui features válidas para visualização ou importação.
        </div>
    </div>
</ng-template>